class GameConfig {
    public readonly tileSize = 32;
    public readonly playerColors = {
        0: 0x2965f2,
        1: 0xf23629,
        2: 0x28f128,
        3: 0xeaf027,
    };
    public readonly spritesheetUrl = 'images/sprites.json';
}

export default Object.freeze(new GameConfig());



// WEBPACK FOOTER //
// ./src/game/GameConfig.ts